export default __webpack_public_path__ + "static/media/four.e802f47e.jpeg";